import { FormHelperText } from "@mui/material";
import SelectDropdown from "../Common/SelectDropdown";
import { useEffect } from "react";

type SelectActionProps = {
    chosenAction: string;
    actionsForService: Record<string, any>;
    workflowType: string;
    onSave: (action: string) => void;
    nodeConfig: Record<string, any>;
    isTriggerNode: boolean;
    getNodeConfigsForNodeFromRef: (nodeId: string) => Record<string, any>;
    nodeId: string;
};

const SelectAction = ({
    chosenAction,
    actionsForService,
    workflowType, 
    onSave,
    nodeConfig,
    isTriggerNode,
    getNodeConfigsForNodeFromRef,
    nodeId,
}: SelectActionProps) => {
    // Filter and transform actions based on trigger node type
    const selectOptions = actionsForService && Object.keys(actionsForService).length ? 
        Object.entries(actionsForService)
            // For trigger nodes, only include actions with Type 1 or 2
            // For non-trigger nodes, only include actions with Type 0
            .filter(([, actionValue]) => 
                (!isTriggerNode && actionValue.Type === 0) || 
                (isTriggerNode && [1,2].includes(actionValue.Type))
            )
            // Transform to format expected by SelectDropdown
            .map(([actionKey]) => ({
                id: actionKey,
                title: actionKey
            }))
        : [];

    // Auto-select single option if available
    // Disabling for now: on creating a new node action from prev is selected
    // would need better state management to debug this
    // useEffect(() => {
    //     if (!chosenAction && selectOptions.length === 1 && getNodeConfigsForNodeFromRef(nodeId)) {
    //         const option = selectOptions[0];
    //         onSave(option.id);
    //     }
    // }, [selectOptions.length]);

    return (
        <div>
            {isTriggerNode ? 
                <FormHelperText>
                    Event in {workflowType} that starts this workflow
                </FormHelperText> 
            : null}
            
            <SelectDropdown
                defaultSelected={{
                    id: chosenAction,
                    title: chosenAction
                }}
                additionalClasses="mt-1"
                selectionOptions={selectOptions}
                onOptionSelection={(selectedOption) => {
                    onSave(selectedOption);
                }}
                size="small"
                disabled={!!chosenAction}
            />
        </div>
    );
}

export default SelectAction;